export const error = {
  zh: {
    serverError: "獲取圖表資料發生一些問題... 請再試一次或聯繫 Growin 團隊",
    noData: "沒有該標的相關資料",
  },
  en: {
    serverError:
      "There was an issue fetching the chart data... Please try again or contact the Growin team",
    noData: "No data available for this symbol",
  },
};
